<template>
    <div class="AccountPage">
        <q-card
            class="AccountCard"
            bordered
        >
            <q-card-section class="AccountTabs">
                <q-tabs
                    v-model="activeTab"
                    no-caps
                    inline-label
                    align="left"
                    active-color="primary"
                    indicator-color="primary"
                >
                    <q-tab
                        name="account"
                        :label="$t('general.account')"
                        icon="account_circle"
                    />
                    <q-tab
                        name="api"
                        :label="$t('general.apis')"
                        icon="api"
                    />
                </q-tabs>
            </q-card-section>

            <q-separator />

            <q-card-section class="AccountBody">
                <template v-if="activeTab === 'account'">
                    <div>
                        <div class="text-subtitle1 mb-1">
                            {{ $t('settings.sections.personal') }}
                        </div>
                        <div>
                            <div class="text-body2 q-pb-sm q-mb-sm">
                                <span>
                                    {{ $t('settings.personal.text1') }}
                                </span>
                                <span class="text-weight-medium">
                                    {{ $t('settings.personal.text2', { name: project }) }}
                                </span>
                                <span>
                                    {{ $t('settings.personal.text3') }}
                                </span>
                            </div>
                            <UserForm
                                v-model:user="user"
                                :disabled="isLoading"
                                @on-submit="update"
                            />
                        </div>
                    </div>
                    <q-separator class="q-my-md" />
                    <div>
                        <div class="text-subtitle1 mb-1">
                            {{ $t('settings.sections.security') }}
                        </div>

                        <div class="Wrapper">
                            <div class="text-body2 q-pb-sm q-mb-sm">
                                {{ $t('settings.security.text') }}
                            </div>
                            <QBtn
                                :disable="isLoading"
                                :label="$t('settings.security.btn')"
                                class="buttonStyle"
                                color="primary"
                                noCaps
                                outline
                                @click="handleClickRecoveryPassword"
                            />
                        </div>
                    </div>

                    <ModalRequest
                        ref="recoveryDialog"
                        :title="$t('settings.modals.recovery.title')"
                        :text="$t('settings.modals.recovery.text')"
                        @on-accept="recoveryPassword"
                    />
                </template>

                <template v-else>
                    <div class="ApiTab">
                        <ApiDoc />
                    </div>
                </template>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>
import Config from '@/config'
import {
    Api, apiRequest, notifySuccess, notifyError,
} from '@/api'
import { ModalRequest } from '@/components'
import { UserForm } from '@/forms'
import ApiDoc from '@/screens/Doc/Doc.vue'

export default {
    name: 'AccountScreen',
    components: {
        UserForm,
        ModalRequest,
        ApiDoc,
    },
    inject: ['App'],
    data() {
        const { user, enviroment } = this.App
        return {
            activeTab: 'account',
            isSyncingTab: false,
            user: { ...user },
            enviroment: { ...enviroment },
            isLoading: false,
        }
    },
    watch: {
        'App.user': {
            handler(value) {
                if (value) this.user = value
            },
            immediate: true,
        },
        '$route.name': {
            handler() {
                this.syncActiveTabFromRoute()
            },
            immediate: true,
        },
        activeTab(value) {
            if (this.isSyncingTab) return

            if (value === 'api' && this.$route?.name !== 'Doc') {
                this.$router.push({ name: 'Doc' }).catch(() => {})
            }

            if (value === 'account' && this.$route?.name !== 'Account') {
                this.$router.push({ name: 'Account' }).catch(() => {})
            }
        },
    },
    beforeCreate() {
        const { name } = Config.project || {}
        this.project = name
    },
    methods: {
        syncActiveTabFromRoute() {
            this.isSyncingTab = true
            this.activeTab = this.$route?.name === 'Doc' ? 'api' : 'account'
            this.$nextTick(() => {
                this.isSyncingTab = false
            })
        },
        handleClickRecoveryPassword() {
            this.$refs.recoveryDialog.open()
        },
        async update() {
            this.isLoading = true
            apiRequest(Api().users.update(this.user))
                .then(() => {
                    this.App.setUser(this.user)
                    notifySuccess(this.$t('settings.notifications.personal.text'))
                })
                .catch(notifyError)
                .finally(() => {
                    this.isLoading = false
                })
        },
        async recoveryPassword() {
            this.isLoading = true
            apiRequest(Api().users.resetPassword())
                .then(() => {
                    this.$refs.recoveryDialog.close()
                    notifySuccess(this.$t('settings.notifications.resetPassword.text'))
                })
                .catch(notifyError)
                .finally(() => { this.isLoading = false })
        },
    },
}
</script>
<style scoped lang="scss">
.AccountPage {
    width: 100%;
}

.AccountCard {
    background: $white;
}

.AccountTabs {
    padding: 0 16px;

    :deep(.q-tab__label) {
        letter-spacing: 1.25px;
    }
}

.AccountBody {
    padding: 16px;
}

:deep(.ApiTab .q-card--bordered) {
    border: 0;
}

:deep(.ApiTab .q-card) {
    box-shadow: none;
}

.Personal {
    line-height: 1.4;
}
</style>
